import { Component, OnInit } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import { AuthenticationService } from '../services/authentication.service';
import { FriendsService } from '../services/friends.service';

@Component({
  selector: 'app-friends',
  templateUrl: './friends.component.html',
  styleUrls: ['./friends.component.scss']
})
export class FriendsComponent implements OnInit {

  public userFriends: Array<any>= [];
  public foundUsers: Array<any> = [];
  public userError: String;

  constructor(private AuthenticationService: AuthenticationService, private FriendsService: FriendsService, private toastr: ToastrService) { }

  ngOnInit() {
    this.getUsersFriends(this.AuthenticationService.id());
  }

  searchMe() {
    this.searchFriends('Cullen Kirkpatrick');
  }

  getUsersFriends(userId) {
    this.FriendsService.getUserFriends(userId).subscribe(
      (data: Array<any>) => { 
        this.userFriends = data;
      },
      err => console.error(err)
    );
  }

  deleteFriend(friendId) {
    this.FriendsService.deleteFriend(friendId).subscribe(
      data => {
        this.toastr.error('Friend Deleted.');
        this.getUsersFriends(this.AuthenticationService.id());
      },
      err => console.error(err)
    );
  }

  searchFriends(friend) {
    if (friend && friend.length > 4) {
      this.userError = undefined;
      this.FriendsService.findFriendByEmailOrName(friend).subscribe(
        (data: Array<any>) => { 
          this.foundUsers = data;
        },
        err => console.error(err)
      );
    } else {
      this.userError = "Please narrow your search terms.";
    }
  }

  addFriend(friend) {
    var newFriend = {
      "userId": this.AuthenticationService.id(),
	    "friend": {
		    "id": friend._id,
		    "name": friend.profile.firstName + ' ' + friend.profile.lastName
      }
    };
    this.FriendsService.addFriend(newFriend).subscribe(
      data => {
        this.toastr.success('Friend Added.');
        this.getUsersFriends(this.AuthenticationService.id());
      },
      err => {
        // SHOW FRIEND EXISTS
        this.userError = "You're already friends with that user."
      }
    );
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/friends/friends.component.ts